import { notification } from 'antd';
export function noticeError(description: string) {
  notification.error({
    message: '接口错误',
    description,
    duration: 0,
    placement: 'bottomRight', // 也可以是 bottomLeft
    onClick: () => {
      console.log('Notification Clicked!');
    },
  });
}
